import endpoints from '@app/src/api/endpoints'
import { FetchKey } from '@app/src/api/fetchHooks'
import Filter from '@app/src/pages/ResourceCollection/Filters/Filter'
import FilterFacetSelect from '@app/src/pages/ResourceCollection/Filters/FilterFacetSelect'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { SortOrder } from '@app/src/types/filter'
import React from 'react'
import { useIntl } from 'react-intl'

const IndustryFilterSelect: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <Filter operator={Operators.In} name="industry.id">
      {({ value, onChange, filterName }) => (
        <FilterFacetSelect
          size="small"
          multiple
          facetsParam={{
            key: [FetchKey.NaceCodes, filterName],
            endpoint: endpoints.naceCodesWithFacets,
            facetsParam: [
              {
                name: 'description',
              },
            ],
            sort: { target: 'label', order: SortOrder.ASCENDING },
          }}
          disableAutoFilter
          filterName={filterName}
          onChange={onChange}
          fieldLabel={formatMessage({ id: 'claim.createClaim.orgInfoStep.industry' })}
          value={[value].flat()}
        />
      )}
    </Filter>
  )
}

export default IndustryFilterSelect
